<template>
	<router-link :to="`/${siteSlug}/cart`" class="d-flex justify-content-between">
		<div class="align-self-center">
			<svg :class="`shopping-bag-${cartType} align-self-center`" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="34" height="34">
				<path d="M0 0h24v24H0z" fill="none" />
				<path d="M17.21 9l-4.38-6.56a.993.993 0 00-.83-.42c-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
			</svg>
			<span v-if="cart && cart.extra && cart.extra.number_of_items > 0" class="badge badge-primary badge-pill custom-card-qty">
				{{ cart.extra.number_of_items }}
			</span>
		</div>
		<div class="navbar-price align-self-center mt-2" v-if="cart && cart.extra.number_of_items > 0">
			{{ realTotal | moneyFormat }}
		</div>
	</router-link>
</template>

<script>
export default {
	props: ['siteSlug', 'cart', 'cartType', 'total', 'showQuantity'],
	computed: {
		realTotal() {
			if (!this.cart) {
				return 0;
			}

			return this.total != null
				? this.total
				: Math.max(
					0,
					this.cart.extra.total_amount -
					this.cart.extra.discounts.total_discount -
					(this.cart.extra.eotho_discount_amount || 0)
				);
		}
	}
};
</script>

<style lang="scss" scoped>
.custom-card-qty {
	margin-left: -17px;
	margin-top: 5px;
}</style>
